import axios from "axios";

export default class {
	constructor(vuex) {
		this.vuex = vuex
		if(process.env.NODE_ENV !== 'production') {
			this.api = 'http://localhost:8081'
		} else {
			this.api = 'https://live.ecconia.de'
		}
	}

	commit(method, data) {
		this.vuex.commit(method, data)
	}

	post(path, data) {
		//TODO: Global error thing.
		return axios
				.post(this.api + path, data)
				.catch((error) => {
					// eslint-disable-next-line
					console.error('Error while sending POST request to ' + this.api + path + ' with data ' + JSON.stringify(data) + ':', error)
				})
	}

	postCatchFWD(path, data) {
		//TODO: Global error thing.
		return axios
				.post(this.api + path, data)
				.catch((error) => {
					// eslint-disable-next-line
					console.error('Error while sending POST request to ' + this.api + path + ' with data ' + JSON.stringify(data) + ':', error)
					throw error //Forward the error for next consumer
				})
	}

	get(path) {
		//TODO: Global error thing.
		return axios
				.get(this.api + path)
				.catch((error) => {
					// eslint-disable-next-line
					console.error('Error while sending GET request to ' + this.api + path + ':', error)
				})
	}

	logout() {
		localStorage.removeItem('user');
			this.commit('setUser', null)
	}

	login(username, password) {
		//TODO: return promise somehow
		this.post('/login', {
			username: username,
			password: password,
		}).then((response) => {
			localStorage.setItem('user', JSON.stringify(response.data));
			this.commit('setUser', response.data)
		})
	}
}